/**
 * Per-lambda IAM policy lists in phx-api-v2 store only policies beyond the group's
 * `iam_policy_names` / `iam_policy_names_custom`. This strips group entries from a
 * lambda list (including legacy configs that stored the full merged list).
 */
export function lambdaIamPoliciesRelativeToGroup(
  lambdaPolicies: string[] | undefined,
  groupPolicies: string[],
): string[] {
  if (!lambdaPolicies?.length) {
    return [];
  }
  if (!groupPolicies.length) {
    return [...lambdaPolicies];
  }
  const groupSet = new Set(groupPolicies);
  return lambdaPolicies.filter(p => !groupSet.has(p));
}
